import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4e9f3695&"
import script from "./Catalog.ts?vue&type=script&lang=ts&"
export * from "./Catalog.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports